/* eslint-disable @typescript-eslint/no-explicit-any */

import { Formalite, useFormaliteService } from '@europrocurement/l2d-domain';
import {
    FormaliteJsonldFormaliteCreate,
    FormaliteJsonldFormaliteUpdate,
} from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { useApiRequest } from '@europrocurement/l2d-hooks';

const useFormalityFormHandler = () => {
    const { formaliteApi } = useFormaliteService();
    const { request, requestState } = useApiRequest();

    const updateFormality = async (formality: Formalite, payload: FormaliteJsonldFormaliteUpdate) =>
        new Promise((resolve) => {
            request(
                formaliteApi.apiFormalitesIdPut({
                    id: formality.id as unknown as string,
                    formaliteJsonldFormaliteUpdate: {
                        ...{
                            categorie: formality?.categorie?.id as unknown as string,
                            libelle: formality.libelle,
                            informationsSupplementaires: formality.informationsSupplementaires,
                            iconeName: formality.iconeName,
                            deleted: formality.deleted,
                            legalStatuses: formality.legalStatuses,
                            compatibilities: formality.compatibilities,
                            documents: formality.documents,
                            validators: formality.validators,
                        },
                        ...payload,
                    },
                }),
                {
                    successCallback: resolve,
                },
            );
        });

    const handleCreateForm = async (formData: { [key: string]: any }) =>
        new Promise((resolve) => {
            const { categorie, libelle, informationsSupplementaires, iconeName, formulaire, rang } =
                formData;

            const payload: FormaliteJsonldFormaliteCreate = {
                categorie: categorie?.id,
                libelle,
                informationsSupplementaires,
                iconeName,
                deleted: false,
                documents: [],
                formulaire: formulaire?.id,
                rang: Number(rang),
            };

            request(
                formaliteApi.apiFormalitesPost({
                    formaliteJsonldFormaliteCreate: payload,
                }),
                {
                    successCallback: resolve,
                },
            );
        });

    const handleEditForm = async (formality: Formalite, formData: { [key: string]: any }) => {
        const { libelle, informationsSupplementaires, categorie, iconeName, formulaire, rang } =
            formData;

        const payload: FormaliteJsonldFormaliteUpdate = {
            categorie: categorie?.id,
            libelle,
            informationsSupplementaires,
            iconeName,
            documents: formality.documents,
            formulaire: formulaire?.id,
            rang: Number(rang),
        };

        return updateFormality(formality, payload);
    };

    return { handleCreateForm, handleEditForm, updateFormality, requestState };
};

export default useFormalityFormHandler;
